import * as React from 'react';

const MOBILE_BREAKPOINT = 768;
const QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

/**
 * Whether the viewport is phone-sized.
 *
 * Deviation from the stock shadcn hook, which held the value in `useState`,
 * initialised it to `undefined`, and assigned it inside an effect. That renders
 * one frame with the wrong answer — the sidebar briefly mounts in desktop mode
 * on a phone — and trips the React Compiler's set-state-in-effect rule.
 *
 * `useSyncExternalStore` is the primitive built for exactly this: it reads the
 * correct value during the first render and subscribes for changes, with no
 * effect and no intermediate wrong state.
 */
function subscribe(onChange: () => void): () => void {
  const media = window.matchMedia(QUERY);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
}

function getSnapshot(): boolean {
  return window.matchMedia(QUERY).matches;
}

/** Non-browser renders (tests, any future SSR) assume desktop. */
function getServerSnapshot(): boolean {
  return false;
}

export function useIsMobile(): boolean {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
